// frontend/src/AddCustomer/AddCustomer.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createCustomer } from '../api/customerApi';
import styles from './AddCustomer.module.css';
import masaLogo from '../Assets/MasaLogo.png';

const AddCustomer = () => {
  const navigate = useNavigate();
  const [customerData, setCustomerData] = useState({ name: '', customerID: ''});
  const [error, setError] = useState(null);
  const userid = localStorage.getItem('userid');

  const handleChange = (e) => {
    setCustomerData({ ...customerData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createCustomer(customerData);
      navigate('/customers');
    } catch (err) {
      // Show the backend 'message'
      setError(err.response?.data?.message || 'Failed to create customer.');
    }
  };

  const handleCancel = () => {
    navigate('/customers');
  };

  return (
    <div className={styles.addCustomerContainer}>
      <header className={styles.header}>
        <img src={masaLogo} alt="Dashboard Logo" className={styles.logo} />
        <h1 className={styles.pageTitle}>Add New Customer</h1>
      </header>

      <main className={styles.mainContent}>
        <form onSubmit={handleSubmit} className={styles.customerForm}>
          <h2>Create Customer</h2>
          {error && <p className={styles.errorMessage}>{error}</p>}

          <label htmlFor="name">Customer Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={customerData.name}
            onChange={handleChange}
            required
            placeholder="Enter customer name"
            className={styles.formInput}
          />

          <label htmlFor="customerID">Customer ID:</label>
          <input
            type="text"
            id="customerID"
            name="customerID"
            value={customerData.customerID}
            onChange={handleChange}
            required
            placeholder="Enter unique customer ID"
            className={styles.formInput}
          />
          <label htmlFor="userid">User ID:</label>
          <input
            type="text"
            id="userid"
            name="userid"
            value={userid}
            readOnly
            className={styles.formInput}

          />
        </form>
      </main>
    </div>
  );
};

export default AddCustomer;
